import { render } from "./portraits-content.vue?vue&type=template&id=0f0559ba&scoped=true"
import script from "./portraits-content.vue?vue&type=script&lang=js"
export * from "./portraits-content.vue?vue&type=script&lang=js"

import "./portraits-content.vue?vue&type=style&index=0&id=0f0559ba&lang=scss&scoped=true"

import exportComponent from "F:\\my-work\\company\\yuanxi\\yuanxi-csspw\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f0559ba"]])

export default __exports__